var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5028"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 3109",
    fill: "none",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3110",
    d: "M8 0h18a8 8 0 018 8H0a8 8 0 018-8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3111",
    fill: "#fff",
    d: "M8 13h3v3H8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3118",
    fill: "#fff",
    d: "M8 18h3v3H8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3122",
    fill: "#fff",
    d: "M8 23h3v3H8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3112",
    fill: "#fff",
    d: "M13 13h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3117",
    fill: "#fff",
    d: "M13 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3121",
    fill: "#fff",
    d: "M13 23h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3113",
    fill: "#fff",
    d: "M18 13h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3116",
    fill: "#fff",
    d: "M18 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3120",
    fill: "#fff",
    d: "M18 23h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3114",
    fill: "#fff",
    d: "M23 13h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3115",
    fill: "#fff",
    d: "M23 18h3v3h-3z"
  }))));
}

export default SvgCalendarIcon;